/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './nips-score.reducer';

export const NipsScoreDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const nipsScoreEntity = useAppSelector(state => state.nipsScore.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="nipsScoreDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.nipsScore.detail.title">NipsScore</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.nipsScore.id">Id</Translate>
            </span>
          </dt>
          <dd>{nipsScoreEntity.id}</dd>
          <dt>
            <span id="facialExpression">
              <Translate contentKey="tinyMedicRestApp.nipsScore.facialExpression">Facial Expression</Translate>
            </span>
          </dt>
          <dd>{nipsScoreEntity.facialExpression}</dd>
          <dt>
            <span id="cry">
              <Translate contentKey="tinyMedicRestApp.nipsScore.cry">Cry</Translate>
            </span>
          </dt>
          <dd>{nipsScoreEntity.cry}</dd>
          <dt>
            <span id="breathingPatterns">
              <Translate contentKey="tinyMedicRestApp.nipsScore.breathingPatterns">Breathing Patterns</Translate>
            </span>
          </dt>
          <dd>{nipsScoreEntity.breathingPatterns}</dd>
          <dt>
            <span id="arms">
              <Translate contentKey="tinyMedicRestApp.nipsScore.arms">Arms</Translate>
            </span>
          </dt>
          <dd>{nipsScoreEntity.arms}</dd>
          <dt>
            <span id="legs">
              <Translate contentKey="tinyMedicRestApp.nipsScore.legs">Legs</Translate>
            </span>
          </dt>
          <dd>{nipsScoreEntity.legs}</dd>
          <dt>
            <span id="stateOfArousal">
              <Translate contentKey="tinyMedicRestApp.nipsScore.stateOfArousal">State Of Arousal</Translate>
            </span>
          </dt>
          <dd>{nipsScoreEntity.stateOfArousal}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.nipsScore.active">Active</Translate>
            </span>
          </dt>
          <dd>{nipsScoreEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.nipsScore.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{nipsScoreEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.nipsScore.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{nipsScoreEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.nipsScore.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{nipsScoreEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.nipsScore.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{nipsScoreEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.nipsScore.patient">Patient</Translate>
          </dt>
          <dd>{nipsScoreEntity.patient ? nipsScoreEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/nips-score" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/nips-score/${nipsScoreEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default NipsScoreDetail;
